import styled from 'styled-components';

import { IModalSecondAccessStyles } from './interfaces';

export const Container = styled.div``;

export const ModalContent = styled.div<IModalSecondAccessStyles>`
  padding: 24px 24px 0px 24px;

  font-family: 'ChickenSansRegular';
  font-style: normal;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h3 {
    margin-bottom: ${props =>
      props.showModalSharingLocation ? '20px' : '46px'};
    text-align: center;
  }

  p {
    text-decoration: none;
    font-family: ChickenSansRegular;
    margin: 0 0px 24px;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }

  button {
    margin-bottom: 15px;
  }

  a {
    text-decoration: none;
    color: var(--color-burnt-orange);

    margin-left: 5px;
    :hover {
      opacity: 0.4;
    }
  }
`;
